import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../lib/i18n";
import { Button } from "../components/ui/button";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-6 py-20 min-h-[60vh] flex items-center">
      <div className="w-full text-center">
        <h1 className="text-7xl md:text-[9rem] font-extrabold tracking-tight text-sky-700">404</h1>
        <h2 className="mt-2 text-2xl md:text-3xl font-semibold">{t("notFoundTitle")}</h2>
        <p className="mt-4 text-sm md:text-base text-foreground/80 max-w-2xl mx-auto">{t("notFoundText")}</p>

        <div className="mt-8 flex items-center justify-center gap-4">
          <Button asChild>
            <Link to="/">{t("home")}</Link>
          </Button>

          <Button asChild variant="outline">
            <Link to="/contact">{t("contact")}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
